export default __webpack_public_path__ + "static/prompt_graph_swe-ed091e48f188539de820851ce26915de.png";